import { render, staticRenderFns } from "./ModalEditAmount.vue?vue&type=template&id=03227004&scoped=true&"
import script from "./ModalEditAmount.vue?vue&type=script&lang=ts&"
export * from "./ModalEditAmount.vue?vue&type=script&lang=ts&"
import style0 from "./ModalEditAmount.vue?vue&type=style&index=0&id=03227004&lang=scss&scoped=true&"
import style1 from "./ModalEditAmount.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03227004",
  null
  
)

export default component.exports